export const pluralize = ({
  count,
  pluralOverride,
  word,
}: {
  count: number
  pluralOverride?: string
  word: string
}): string => {
  if (count === 1) {
    return word
  }

  if (pluralOverride) {
    return pluralOverride
  }

  return `${word}s`
}
